'use client';

import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import { BIGCOMMERCE_GRAPHQL_API_ENDPOINT } from '../big-commerce/constants';

export const client = new ApolloClient({
  link: new HttpLink({
    uri: BIGCOMMERCE_GRAPHQL_API_ENDPOINT,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.BIGCOMMERCE_STOREFRONT_API_TOKEN}`,
    },
  }),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});
